/**
 * Moduł dostępności (WCAG 2.1 AA) — POOM Furniture
 *
 * Samodzielny widget: bez zewnętrznych usług, bez cookies (localStorage).
 * Element własny: <accessibility-widget>
 *
 * API globalne:
 *   window.poomA11y.open() / .close() / .toggle() / .reset()
 * Otwieranie z dowolnego miejsca w motywie:
 *   <a href="#dostepnosc">…</a>  albo  <button data-a11y-open>…</button>
 */

const STORE_KEY = 'poom-a11y-v1';

const FONT_STEPS = [1, 1.12, 1.25, 1.4, 1.6];

const ICONS = {
  accessibility:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="10.2" stroke="currentColor" stroke-width="1.5"/><circle cx="12" cy="6.4" r="1.7" fill="currentColor"/><path d="M5.9 9.3c3.9 1.2 8.3 1.2 12.2 0M12 9.9v4.2m0 0 2.6 5.3M12 14.1l-2.6 5.3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
  contrast:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/><path d="M12 3a9 9 0 0 1 0 18V3Z" fill="currentColor"/></svg>',
  textSize:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M3 7V5h9v2M7.5 5v14M5.5 19h4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.5 12v-1.4h7.5V12M17.2 10.6V19m-1.6 0h3.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  spacing:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M6 6.5v11M18 6.5v11" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M9 12h6m0 0-2.2-2.2M15 12l-2.2 2.2M9 12l2.2-2.2M9 12l2.2 2.2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  lineHeight:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M10 5.5h11M10 12h11M10 18.5h11" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M4.5 4v16m0-16L2.7 6M4.5 4l1.8 2M4.5 20l-1.8-2M4.5 20l1.8-2" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  font: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M4 19 10.2 5h1.6L18 19M6.8 14.4h8.4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  align:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M4 6h16M4 10.7h10M4 15.3h16M4 20h10" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
  link: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M10.2 13.8a3.6 3.6 0 0 0 5.1 0l2.9-2.9a3.6 3.6 0 1 0-5.1-5.1l-1.3 1.3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M13.8 10.2a3.6 3.6 0 0 0-5.1 0l-2.9 2.9a3.6 3.6 0 1 0 5.1 5.1l1.3-1.3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
  heading:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M5 5v14M13 5v14M5 12h8" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/><path d="M17 19v-6.5c0-1.4 1-2.3 2.2-2.3s2.3.9 2.3 2.3V19" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
  motion:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.7"/><path d="M9.6 9v6M14.4 9v6" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/></svg>',
  image:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><rect x="3.2" y="4.8" width="17.6" height="14.4" rx="2.4" stroke="currentColor" stroke-width="1.7"/><path d="m4.4 17 4.4-4.4 3.2 3.2 3-3 4.6 4.6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/><path d="m3 3 18 18" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/></svg>',
  saturation:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M12 3.2s6 6.3 6 10.1a6 6 0 1 1-12 0C6 9.5 12 3.2 12 3.2Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M12 3.2s6 6.3 6 10.1a6 6 0 0 1-6 6V3.2Z" fill="currentColor"/></svg>',
  cursor:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M5.5 3.4 18 12l-5.3 1 2.7 6.2-2.5 1.1-2.8-6.3-4.6 3.6z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>',
  mask: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><rect x="3" y="4" width="18" height="4.5" rx="1.2" fill="currentColor" opacity=".85"/><rect x="3" y="15.5" width="18" height="4.5" rx="1.2" fill="currentColor" opacity=".85"/><rect x="3" y="10" width="18" height="4" rx="1.2" stroke="currentColor" stroke-width="1.6"/></svg>',
  guide:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M3 12h18" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/><path d="M5 7.2h14M5 16.8h14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" opacity=".45"/></svg>',
  focus:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M4 8.5V6a2 2 0 0 1 2-2h2.5M20 8.5V6a2 2 0 0 0-2-2h-2.5M4 15.5V18a2 2 0 0 0 2 2h2.5M20 15.5V18a2 2 0 0 1-2 2h-2.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><circle cx="12" cy="12" r="3" fill="currentColor"/></svg>',
  sticky:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><rect x="3.2" y="4" width="17.6" height="5" rx="1.6" stroke="currentColor" stroke-width="1.7"/><path d="M12 11.5v8m0 0-2.6-2.6M12 19.5l2.6-2.6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  reset:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M19.4 12a7.4 7.4 0 1 1-2.2-5.3" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/><path d="M19.6 3.6V7.4h-3.8" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  close:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M6 6 18 18M18 6 6 18" stroke="currentColor" stroke-width="2.1" stroke-linecap="round"/></svg>',
  check:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="m5 12.6 4.6 4.6L19 6.9" stroke="currentColor" stroke-width="3.1" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  doc: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M6 3.5h7.5L19 9v11.5H6z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M13.2 3.6V9.2H18.8M9 13h6M9 16.5h4.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
  eye: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M2.6 12S6.4 5.8 12 5.8 21.4 12 21.4 12 17.6 18.2 12 18.2 2.6 12 2.6 12Z" stroke="currentColor" stroke-width="1.6"/><circle cx="12" cy="12" r="2.9" stroke="currentColor" stroke-width="1.6"/></svg>',
  brain:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M9.4 4.2A2.7 2.7 0 0 0 6.8 7c-1.4.4-2.3 1.6-2.3 3 0 .9.4 1.7 1 2.3-.5.5-.8 1.2-.8 2 0 1.7 1.4 3 3.1 3 .4 1.3 1.6 2.2 3 2.2h.6V4.2z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M14.6 4.2A2.7 2.7 0 0 1 17.2 7c1.4.4 2.3 1.6 2.3 3 0 .9-.4 1.7-1 2.3.5.5.8 1.2.8 2 0 1.7-1.4 3-3.1 3-.4 1.3-1.6 2.2-3 2.2H12" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>',
  senior:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><circle cx="10.5" cy="5" r="2.3" stroke="currentColor" stroke-width="1.6"/><path d="M10.5 9.2c-2 0-3 1.3-3.2 3l-.6 3.4h2l.5 5.2h2.6l.5-5.2h2l-.6-3.4c-.2-1.7-1.2-3-3.2-3Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M18.4 8.5V21" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
  bolt: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M13.6 2.6 5.4 13.4h5.3l-.9 8 8.2-10.8h-5.3z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
  keyboard:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><rect x="2.6" y="6" width="18.8" height="12" rx="2.2" stroke="currentColor" stroke-width="1.6"/><path d="M6.2 9.6h.01M9.6 9.6h.01M13 9.6h.01M16.4 9.6h.01M6.2 12.8h.01M9.6 12.8h.01M13 12.8h.01M16.4 12.8h.01M8.4 15.6h7.2" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"/></svg>',
  dyslexia:
    '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M4 19V5h4.6c3.9 0 6.2 2.6 6.2 7s-2.3 7-6.2 7z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M17.4 9.6V19" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
};

/* --------------------------------------------------------------------------
   Definicja ustawień
   Każdy kafelek to jedna opcja: 'toggle' (wł./wył.) lub lista wartości.
   -------------------------------------------------------------------------- */

const OPTIONS = [
  { key: 'contrast', icon: 'contrast', attr: 'data-a11y-contrast', values: [null, 'light', 'dark', 'yellow', 'black-yellow'] },
  { key: 'font', icon: 'textSize', attr: null, values: [0, 1, 2, 3, 4] },
  { key: 'spacing', icon: 'spacing', attr: 'data-a11y-spacing', values: [null, '1', '2', '3'] },
  { key: 'lineheight', icon: 'lineHeight', attr: 'data-a11y-lineheight', values: [null, '1', '2', '3'] },
  { key: 'fontFamily', icon: 'font', attr: 'data-a11y-font-family', values: [null, 'readable', 'mono'] },
  { key: 'align', icon: 'align', attr: 'data-a11y-align', values: [null, 'left', 'center'] },
  { key: 'links', icon: 'link', attr: 'data-a11y-links', values: [null, '1', '2'] },
  { key: 'headings', icon: 'heading', attr: 'data-a11y-headings', values: [null, '1'] },
  { key: 'motion', icon: 'motion', attr: 'data-a11y-motion', values: [null, '1'] },
  { key: 'images', icon: 'image', attr: 'data-a11y-images', values: [null, '1'] },
  { key: 'filter', icon: 'saturation', attr: 'data-a11y-filter', values: [null, 'grayscale', 'low', 'high'] },
  { key: 'cursor', icon: 'cursor', attr: 'data-a11y-cursor', values: [null, '1', '2'] },
  { key: 'mask', icon: 'mask', attr: null, values: [null, '1'] },
  { key: 'guide', icon: 'guide', attr: null, values: [null, '1'] },
  { key: 'focus', icon: 'focus', attr: 'data-a11y-focus', values: [null, '1'] },
  { key: 'sticky', icon: 'sticky', attr: 'data-a11y-sticky', values: [null, 'off'] },
];

const PROFILES = [
  { key: 'lowVision', icon: 'eye', state: { font: 3, contrast: 1, links: 1, lineheight: 1, focus: 1 } },
  { key: 'dyslexia', icon: 'dyslexia', state: { fontFamily: 2, spacing: 2, lineheight: 2, align: 1 } },
  { key: 'adhd', icon: 'brain', state: { mask: 1, motion: 1, filter: 2 } },
  { key: 'senior', icon: 'senior', state: { font: 2, cursor: 1, links: 1, lineheight: 1, focus: 1 } },
  { key: 'epilepsy', icon: 'bolt', state: { motion: 1, filter: 1 } },
  { key: 'keyboard', icon: 'keyboard', state: { focus: 1, links: 1, sticky: 1 } },
];

/* --------------------------------------------------------------------------
   Tłumaczenia
   -------------------------------------------------------------------------- */

const I18N = {
  pl: {
    title: 'Dostępność',
    subtitle: 'Dostosuj stronę do swoich potrzeb',
    open: 'Otwórz menu dostępności',
    close: 'Zamknij menu dostępności',
    profiles: 'Profile dostępności',
    settings: 'Ustawienia szczegółowe',
    reset: 'Resetuj ustawienia',
    statement: 'Deklaracja dostępności',
    shortcut: 'CTRL + U',
    on: 'włączone',
    off: 'wyłączone',
    resetDone: 'Przywrócono ustawienia domyślne.',
    profileOn: 'Włączono profil:',
    profileOff: 'Wyłączono profil:',
    options: {
      contrast: { label: 'Kontrast', values: ['wyłączony', 'jasny', 'ciemny', 'żółty na czarnym', 'czarny na żółtym'] },
      font: { label: 'Rozmiar tekstu', values: ['100%', '112%', '125%', '140%', '160%'] },
      spacing: { label: 'Odstępy tekstu', values: ['standardowe', 'małe', 'średnie', 'duże'] },
      lineheight: { label: 'Wysokość linii', values: ['standardowa', 'średnia', 'duża', 'bardzo duża'] },
      fontFamily: { label: 'Czytelna czcionka', values: ['standardowa', 'bezszeryfowa', 'dla dyslektyków'] },
      align: { label: 'Wyrównanie tekstu', values: ['standardowe', 'do lewej', 'wyśrodkowane'] },
      links: { label: 'Podświetl linki', values: ['wyłączone', 'obramowanie', 'wyróżnienie'] },
      headings: { label: 'Podświetl nagłówki', values: ['wyłączone', 'włączone'] },
      motion: { label: 'Zatrzymaj animacje', values: ['wyłączone', 'włączone'] },
      images: { label: 'Ukryj obrazy', values: ['wyłączone', 'włączone'] },
      filter: { label: 'Nasycenie', values: ['standardowe', 'odcienie szarości', 'niskie', 'wysokie'] },
      cursor: { label: 'Duży kursor', values: ['standardowy', 'duży', 'bardzo duży'] },
      mask: { label: 'Maska czytania', values: ['wyłączona', 'włączona'] },
      guide: { label: 'Linijka', values: ['wyłączona', 'włączona'] },
      focus: { label: 'Wyraźny fokus', values: ['wyłączony', 'włączony'] },
      sticky: { label: 'Odklej nagłówek', values: ['wyłączone', 'włączone'] },
    },
    profileLabels: {
      lowVision: 'Słabowzroczność',
      dyslexia: 'Dysleksja',
      adhd: 'Koncentracja / ADHD',
      senior: 'Senior',
      epilepsy: 'Bez migotania',
      keyboard: 'Nawigacja klawiaturą',
    },
  },
  en: {
    title: 'Accessibility',
    subtitle: 'Adjust the site to your needs',
    open: 'Open accessibility menu',
    close: 'Close accessibility menu',
    profiles: 'Accessibility profiles',
    settings: 'Detailed settings',
    reset: 'Reset settings',
    statement: 'Accessibility statement',
    shortcut: 'CTRL + U',
    on: 'on',
    off: 'off',
    resetDone: 'Default settings restored.',
    profileOn: 'Profile enabled:',
    profileOff: 'Profile disabled:',
    options: {
      contrast: { label: 'Contrast', values: ['off', 'light', 'dark', 'yellow on black', 'black on yellow'] },
      font: { label: 'Text size', values: ['100%', '112%', '125%', '140%', '160%'] },
      spacing: { label: 'Text spacing', values: ['default', 'small', 'medium', 'large'] },
      lineheight: { label: 'Line height', values: ['default', 'medium', 'large', 'extra large'] },
      fontFamily: { label: 'Readable font', values: ['default', 'sans-serif', 'dyslexia friendly'] },
      align: { label: 'Text align', values: ['default', 'left', 'centered'] },
      links: { label: 'Highlight links', values: ['off', 'outline', 'highlight'] },
      headings: { label: 'Highlight headings', values: ['off', 'on'] },
      motion: { label: 'Stop animations', values: ['off', 'on'] },
      images: { label: 'Hide images', values: ['off', 'on'] },
      filter: { label: 'Saturation', values: ['default', 'grayscale', 'low', 'high'] },
      cursor: { label: 'Big cursor', values: ['default', 'big', 'extra big'] },
      mask: { label: 'Reading mask', values: ['off', 'on'] },
      guide: { label: 'Reading guide', values: ['off', 'on'] },
      focus: { label: 'Strong focus', values: ['off', 'on'] },
      sticky: { label: 'Unstick header', values: ['off', 'on'] },
    },
    profileLabels: {
      lowVision: 'Low vision',
      dyslexia: 'Dyslexia',
      adhd: 'Focus / ADHD',
      senior: 'Senior',
      epilepsy: 'No flashing',
      keyboard: 'Keyboard navigation',
    },
  },
  de: {
    title: 'Barrierefreiheit',
    subtitle: 'Passen Sie die Seite an Ihre Bedürfnisse an',
    open: 'Menü für Barrierefreiheit öffnen',
    close: 'Menü für Barrierefreiheit schließen',
    profiles: 'Profile',
    settings: 'Detaileinstellungen',
    reset: 'Einstellungen zurücksetzen',
    statement: 'Erklärung zur Barrierefreiheit',
    shortcut: 'STRG + U',
    on: 'ein',
    off: 'aus',
    resetDone: 'Standardeinstellungen wiederhergestellt.',
    profileOn: 'Profil aktiviert:',
    profileOff: 'Profil deaktiviert:',
    options: {
      contrast: { label: 'Kontrast', values: ['aus', 'hell', 'dunkel', 'gelb auf schwarz', 'schwarz auf gelb'] },
      font: { label: 'Textgröße', values: ['100%', '112%', '125%', '140%', '160%'] },
      spacing: { label: 'Textabstand', values: ['standard', 'klein', 'mittel', 'groß'] },
      lineheight: { label: 'Zeilenhöhe', values: ['standard', 'mittel', 'groß', 'sehr groß'] },
      fontFamily: { label: 'Lesbare Schrift', values: ['standard', 'serifenlos', 'für Legastheniker'] },
      align: { label: 'Textausrichtung', values: ['standard', 'linksbündig', 'zentriert'] },
      links: { label: 'Links hervorheben', values: ['aus', 'Rahmen', 'Hervorhebung'] },
      headings: { label: 'Überschriften hervorheben', values: ['aus', 'ein'] },
      motion: { label: 'Animationen stoppen', values: ['aus', 'ein'] },
      images: { label: 'Bilder ausblenden', values: ['aus', 'ein'] },
      filter: { label: 'Sättigung', values: ['standard', 'Graustufen', 'niedrig', 'hoch'] },
      cursor: { label: 'Großer Cursor', values: ['standard', 'groß', 'sehr groß'] },
      mask: { label: 'Lesemaske', values: ['aus', 'ein'] },
      guide: { label: 'Leselineal', values: ['aus', 'ein'] },
      focus: { label: 'Starker Fokus', values: ['aus', 'ein'] },
      sticky: { label: 'Header lösen', values: ['aus', 'ein'] },
    },
    profileLabels: {
      lowVision: 'Sehschwäche',
      dyslexia: 'Legasthenie',
      adhd: 'Konzentration / ADHS',
      senior: 'Senioren',
      epilepsy: 'Kein Flackern',
      keyboard: 'Tastaturnavigation',
    },
  },
};

const SCALE_SELECTOR =
  'p,span,a,li,h1,h2,h3,h4,h5,h6,button,label,input,select,textarea,td,th,dd,dt,figcaption,blockquote,strong,em,b,i,small,legend,summary,cite,time,address,div';

const FOCUSABLE =
  'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

/* -------------------------------------------------------------------------- */

class AccessibilityWidget extends HTMLElement {
  constructor() {
    super();
    this.state = {};
    this.isOpen = false;
    this.lastFocused = null;
    this.overlays = {};
    this._onPointerMove = this._onPointerMove.bind(this);
    this._onKeydown = this._onKeydown.bind(this);
  }

  connectedCallback() {
    this.t = I18N[this._lang()] || I18N.pl;
    this.statementUrl = this.getAttribute('data-statement-url') || '';
    // Motyw sam potrafi mieć wyłączone animacje — wtedy nie wolno tego cofać.
    this._themeAnimationsOff = document.body.classList.contains('animations-disabled');
    this.state = this._load();

    this._render();
    this._bind();
    this.apply({ announce: false });

    window.poomA11y = {
      open: () => this.open(),
      close: () => this.close(),
      toggle: () => (this.isOpen ? this.close() : this.open()),
      reset: () => this.reset(),
      state: () => Object.assign({}, this.state),
    };

    document.dispatchEvent(new CustomEvent('poom-a11y:ready'));
  }

  _lang() {
    const raw = (document.documentElement.getAttribute('lang') || 'pl').toLowerCase();
    const short = raw.split('-')[0];
    return I18N[short] ? short : 'pl';
  }

  /* ---------------------------------------------------------------- storage */

  _load() {
    const base = {};
    OPTIONS.forEach((o) => {
      base[o.key] = 0;
    });
    try {
      const raw = window.localStorage.getItem(STORE_KEY);
      if (!raw) return base;
      const saved = JSON.parse(raw);
      OPTIONS.forEach((o) => {
        const v = parseInt(saved[o.key], 10);
        if (!Number.isNaN(v) && v >= 0 && v < o.values.length) base[o.key] = v;
      });
    } catch (e) {
      /* localStorage niedostępny (tryb prywatny) — działamy bez zapisu */
    }
    return base;
  }

  _save() {
    try {
      window.localStorage.setItem(STORE_KEY, JSON.stringify(this.state));
    } catch (e) {
      /* ignorujemy */
    }
  }

  /* ----------------------------------------------------------------- render */

  _render() {
    const t = this.t;

    const profiles = PROFILES.map(
      (p) => `
      <li>
        <button type="button" class="a11y-profile" data-profile="${p.key}" aria-pressed="false">
          ${ICONS[p.icon]}<span>${t.profileLabels[p.key]}</span>
        </button>
      </li>`
    ).join('');

    const tiles = OPTIONS.map((o) => {
      const meta = t.options[o.key];
      const multi = o.values.length > 2;
      const steps = multi
        ? `<span class="a11y-tile__steps" aria-hidden="true">${o.values
            .slice(1)
            .map(() => '<span class="a11y-tile__step"></span>')
            .join('')}</span>`
        : `<span class="a11y-tile__value" data-tile-value></span>`;

      return `
      <li>
        <button type="button" class="a11y-tile" data-option="${o.key}" aria-pressed="false">
          <span class="a11y-tile__check">${ICONS.check}</span>
          <span class="a11y-tile__icon">${ICONS[o.icon]}</span>
          <span class="a11y-tile__label">${meta.label}</span>
          ${steps}
          ${multi ? '<span class="a11y-tile__value" data-tile-value></span>' : ''}
        </button>
      </li>`;
    }).join('');

    const statement = this.statementUrl
      ? `<a class="a11y-statement" href="${this.statementUrl}">${ICONS.doc}<span>${t.statement}</span></a>`
      : '';

    this.innerHTML = `
      <button type="button" class="a11y-fab" aria-expanded="false" aria-controls="a11y-panel" aria-haspopup="dialog">
        ${ICONS.accessibility}
        <span class="a11y-fab__tip" aria-hidden="true">${t.title}</span>
        <span class="a11y-sr">${t.open} (${t.shortcut})</span>
      </button>

      <div class="a11y-backdrop" data-a11y-backdrop></div>

      <div class="a11y-panel" id="a11y-panel" role="dialog" aria-modal="true" aria-labelledby="a11y-title">
        <div class="a11y-panel__header">
          <span class="a11y-panel__header-icon" aria-hidden="true">${ICONS.accessibility}</span>
          <div class="a11y-panel__titles">
            <h2 class="a11y-panel__title" id="a11y-title">${t.title}</h2>
            <p class="a11y-panel__subtitle">${t.subtitle} &middot; <span class="a11y-panel__kbd">${t.shortcut}</span></p>
          </div>
          <button type="button" class="a11y-close" data-a11y-close>
            ${ICONS.close}<span class="a11y-sr">${t.close}</span>
          </button>
        </div>

        <div class="a11y-panel__body">
          <div class="a11y-group">
            <span class="a11y-group__label" id="a11y-profiles-label">${t.profiles}</span>
            <ul class="a11y-profiles" aria-labelledby="a11y-profiles-label">${profiles}</ul>
          </div>
          <div class="a11y-group">
            <span class="a11y-group__label" id="a11y-settings-label">${t.settings}</span>
            <ul class="a11y-tiles" aria-labelledby="a11y-settings-label">${tiles}</ul>
          </div>
        </div>

        <div class="a11y-panel__footer">
          <button type="button" class="a11y-reset" data-a11y-reset>${ICONS.reset}<span>${t.reset}</span></button>
          ${statement}
        </div>
      </div>

      <div class="a11y-sr" aria-live="polite" data-a11y-live></div>
    `;

    this.fab = this.querySelector('.a11y-fab');
    this.panel = this.querySelector('.a11y-panel');
    this.live = this.querySelector('[data-a11y-live]');
  }

  /* ------------------------------------------------------------------- bind */

  _bind() {
    this.fab.addEventListener('click', () => (this.isOpen ? this.close() : this.open()));
    this.querySelector('[data-a11y-close]').addEventListener('click', () => this.close());
    this.querySelector('[data-a11y-backdrop]').addEventListener('click', () => this.close());
    this.querySelector('[data-a11y-reset]').addEventListener('click', () => this.reset());

    this.querySelectorAll('[data-option]').forEach((btn) => {
      btn.addEventListener('click', () => this._cycle(btn.getAttribute('data-option')));
    });

    this.querySelectorAll('[data-profile]').forEach((btn) => {
      btn.addEventListener('click', () => this._toggleProfile(btn.getAttribute('data-profile')));
    });

    document.addEventListener('keydown', this._onKeydown);

    // Otwieranie z dowolnego miejsca motywu (ikona w menu, stopce, tekście).
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-a11y-open], a[href="#dostepnosc"], a[href="#accessibility"], a[href$="#dostepnosc"], a[href$="#accessibility"]');
      if (!trigger || this.contains(trigger)) return;
      e.preventDefault();
      this.open();
    });

    // Zmiana szerokości okna zmienia bazowe rozmiary czcionek w motywie.
    let resizeTimer = null;
    window.addEventListener('resize', () => {
      if (!this.state.font) return;
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => this._rescaleFromScratch(), 350);
    });

    // Treści doładowywane dynamicznie (koszyk, quick view, filtry).
    let mutationTimer = null;
    this.observer = new MutationObserver(() => {
      if (!this.state.font && !this.state.contrast) return;
      window.clearTimeout(mutationTimer);
      mutationTimer = window.setTimeout(() => {
        // Doładowana treść też musi dostać ocenę przezroczystości tła i skalowanie.
        if (this.state.contrast) this._markBackgrounds();
        if (this.state.font) this._scaleText(FONT_STEPS[this.state.font]);
      }, 250);
    });
    this.observer.observe(document.body, { childList: true, subtree: true });
  }

  _onKeydown(e) {
    // CTRL+U — skrót otwierający panel (zgodnie z praktyką narzędzi dostępności)
    if (e.ctrlKey && !e.shiftKey && !e.altKey && (e.key === 'u' || e.key === 'U')) {
      e.preventDefault();
      this.isOpen ? this.close() : this.open();
      return;
    }

    if (!this.isOpen) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      this.close();
      return;
    }

    if (e.key === 'Tab') this._trapFocus(e);
  }

  _trapFocus(e) {
    const items = Array.from(this.panel.querySelectorAll(FOCUSABLE)).filter(
      (el) => el.offsetParent !== null || el === document.activeElement
    );
    if (!items.length) return;

    const first = items[0];
    const last = items[items.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* ------------------------------------------------------------ open/close */

  open() {
    if (this.isOpen) return;
    this.lastFocused = document.activeElement;
    this.isOpen = true;
    this.setAttribute('data-open', 'true');
    this.fab.setAttribute('aria-expanded', 'true');
    const first = this.panel.querySelector('[data-a11y-close]');
    if (first) window.setTimeout(() => first.focus(), 60);
  }

  close() {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.removeAttribute('data-open');
    this.fab.setAttribute('aria-expanded', 'false');
    const target = this.lastFocused && document.contains(this.lastFocused) ? this.lastFocused : this.fab;
    if (target && typeof target.focus === 'function') target.focus();
  }

  /* ---------------------------------------------------------------- zmiany */

  _cycle(key) {
    const option = OPTIONS.find((o) => o.key === key);
    if (!option) return;
    this.state[key] = (this.state[key] + 1) % option.values.length;
    this._save();
    this.apply({ announce: true, changed: key });
  }

  _toggleProfile(key) {
    const profile = PROFILES.find((p) => p.key === key);
    if (!profile) return;

    const active = this._profileActive(profile);
    OPTIONS.forEach((o) => {
      if (Object.prototype.hasOwnProperty.call(profile.state, o.key)) {
        this.state[o.key] = active ? 0 : profile.state[o.key];
      }
    });

    this._save();
    this.apply({ announce: false });
    this._announce(
      (active ? this.t.profileOff : this.t.profileOn) + ' ' + this.t.profileLabels[key]
    );
  }

  _profileActive(profile) {
    return Object.keys(profile.state).every((k) => this.state[k] === profile.state[k]);
  }

  reset() {
    OPTIONS.forEach((o) => {
      this.state[o.key] = 0;
    });
    this._save();
    this.apply({ announce: false });
    this._announce(this.t.resetDone);
  }

  /* ---------------------------------------------------------------- stosuj */

  apply(opts) {
    const options = opts || {};
    const root = document.documentElement;

    // Zanim włączymy kontrast, musimy wiedzieć, które elementy są przezroczyste.
    if (this.state.contrast > 0) this._markBackgrounds();

    OPTIONS.forEach((o) => {
      if (!o.attr) return;
      const value = o.values[this.state[o.key]];
      if (value === null || value === undefined) root.removeAttribute(o.attr);
      else root.setAttribute(o.attr, value);
    });

    // Rozmiar tekstu
    const scale = FONT_STEPS[this.state.font] || 1;
    if (scale === 1) root.removeAttribute('data-a11y-font');
    else root.setAttribute('data-a11y-font', String(this.state.font));
    this._scaleText(scale);

    // Animacje — korzystamy też z klasy wspieranej przez motyw
    if (this.state.motion) {
      document.body.classList.add('animations-disabled');
      document.querySelectorAll('video').forEach((v) => {
        try {
          v.pause();
          v.removeAttribute('autoplay');
        } catch (e) {
          /* ignorujemy */
        }
      });
    } else if (!this._themeAnimationsOff) {
      document.body.classList.remove('animations-disabled');
    }

    this._syncOverlays();
    this._syncUI();

    if (options.announce && options.changed) {
      const meta = this.t.options[options.changed];
      this._announce(meta.label + ': ' + meta.values[this.state[options.changed]]);
    }
  }

  _syncUI() {
    this.querySelectorAll('[data-option]').forEach((btn) => {
      const key = btn.getAttribute('data-option');
      const meta = this.t.options[key];
      const level = this.state[key];
      const active = level > 0;

      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', meta.label + ' — ' + meta.values[level]);

      // Wartość pokazujemy zawsze — także przy przełącznikach („włączone”/„wyłączone”),
      // żeby stan nie zależał wyłącznie od koloru kafelka (WCAG 1.4.1).
      const valueEl = btn.querySelector('[data-tile-value]');
      if (valueEl) valueEl.textContent = meta.values[level];

      const steps = btn.querySelectorAll('.a11y-tile__step');
      steps.forEach((step, i) => step.classList.toggle('is-on', i < level));
    });

    this.querySelectorAll('[data-profile]').forEach((btn) => {
      const profile = PROFILES.find((p) => p.key === btn.getAttribute('data-profile'));
      btn.setAttribute('aria-pressed', this._profileActive(profile) ? 'true' : 'false');
    });
  }

  _announce(message) {
    if (!this.live) return;
    this.live.textContent = '';
    window.setTimeout(() => {
      this.live.textContent = message;
    }, 60);
  }

  /* ------------------------------------------------- tła a tryby kontrastu */

  /**
   * Oznacza elementy atrybutem data-a11y-bg:
   *   "t" — tło przezroczyste lub półprzezroczyste (NIE wolno go przemalowywać),
   *   "o" — tło w pełni nieprzezroczyste (można pomalować kolorem trybu).
   *
   * Bez tego wymuszona czerń robi się z każdej przezroczystej warstwy leżącej na
   * zdjęciu (np. div.slideshow-image-overlay w hero) czarną płachtą i zdjęcia znikają.
   *
   * Pomiar musi się odbyć przy WYŁĄCZONYM kontraście — inaczej wszystko wyszłoby
   * jako nieprzezroczyste. Zdejmujemy atrybut i wracamy z nim w tym samym zadaniu
   * JS, więc przeglądarka nie zdąży nic przerysować.
   */
  _markBackgrounds() {
    const root = document.documentElement;
    const nodes = document.body.querySelectorAll('*:not([data-a11y-bg])');
    if (!nodes.length) return;

    const previous = root.getAttribute('data-a11y-contrast');
    if (previous) root.removeAttribute('data-a11y-contrast');

    const marks = [];
    for (let i = 0; i < nodes.length; i += 1) {
      const el = nodes[i];
      if (el.closest('accessibility-widget')) continue;
      marks.push([el, this._isOpaque(window.getComputedStyle(el).backgroundColor) ? 'o' : 't']);
    }
    for (let i = 0; i < marks.length; i += 1) marks[i][0].setAttribute('data-a11y-bg', marks[i][1]);

    if (previous) root.setAttribute('data-a11y-contrast', previous);
  }

  /** Czy kolor tła jest w pełni kryjący? Obsługuje rgb/rgba oraz zapis color(srgb … / a). */
  _isOpaque(value) {
    if (!value || value === 'transparent') return false;
    const slash = value.match(/\/\s*([\d.]+)\s*\)\s*$/); // color(srgb r g b / a)
    if (slash) return parseFloat(slash[1]) >= 1;
    const rgba = value.match(/^rgba?\(([^)]*)\)$/);
    if (rgba) {
      const parts = rgba[1].split(',');
      if (parts.length < 4) return true; // rgb() — bez kanału alfa
      return parseFloat(parts[3]) >= 1;
    }
    return true;
  }

  /* ------------------------------------------------------- skalowanie tekstu */

  _rescaleFromScratch() {
    document.querySelectorAll('[data-a11y-fs]').forEach((el) => {
      el.style.fontSize = '';
      el.removeAttribute('data-a11y-fs');
    });
    this._scaleText(FONT_STEPS[this.state.font] || 1);
  }

  _scaleText(scale) {
    // Nic nie skalowaliśmy i nie skalujemy — nie ma po co chodzić po DOM.
    if (scale === 1 && !document.querySelector('[data-a11y-fs]')) return;

    const nodes = Array.prototype.slice.call(document.body.querySelectorAll(SCALE_SELECTOR));
    const targets = [];

    // 1) odczyt (bez zapisu — unikamy przeplatania layoutu)
    for (let i = 0; i < nodes.length; i += 1) {
      const el = nodes[i];
      if (el.closest('accessibility-widget')) continue;

      let base = el.getAttribute('data-a11y-fs');
      if (base === null) {
        const computed = parseFloat(window.getComputedStyle(el).fontSize);
        if (!computed) continue;
        base = computed;
        targets.push({ el: el, base: base, store: true });
      } else {
        targets.push({ el: el, base: parseFloat(base), store: false });
      }
    }

    // 2) zapis
    for (let i = 0; i < targets.length; i += 1) {
      const item = targets[i];
      if (item.store) item.el.setAttribute('data-a11y-fs', String(item.base));
      if (scale === 1) item.el.style.fontSize = '';
      else item.el.style.fontSize = (item.base * scale).toFixed(2) + 'px';
    }
  }

  /* ------------------------------------------------------------- nakładki */

  _syncOverlays() {
    const needsPointer = this.state.mask > 0 || this.state.guide > 0;

    if (this.state.mask > 0 && !this.overlays.maskTop) {
      this.overlays.maskTop = document.createElement('div');
      this.overlays.maskTop.className = 'a11y-mask a11y-mask--top';
      this.overlays.maskBottom = document.createElement('div');
      this.overlays.maskBottom.className = 'a11y-mask a11y-mask--bottom';
      this.appendChild(this.overlays.maskTop);
      this.appendChild(this.overlays.maskBottom);
      this._moveOverlays(window.innerHeight / 2);
    } else if (this.state.mask === 0 && this.overlays.maskTop) {
      this.overlays.maskTop.remove();
      this.overlays.maskBottom.remove();
      this.overlays.maskTop = null;
      this.overlays.maskBottom = null;
    }

    if (this.state.guide > 0 && !this.overlays.guide) {
      this.overlays.guide = document.createElement('div');
      this.overlays.guide.className = 'a11y-guide';
      this.appendChild(this.overlays.guide);
      this._moveOverlays(window.innerHeight / 2);
    } else if (this.state.guide === 0 && this.overlays.guide) {
      this.overlays.guide.remove();
      this.overlays.guide = null;
    }

    if (needsPointer && !this._pointerBound) {
      document.addEventListener('pointermove', this._onPointerMove, { passive: true });
      this._pointerBound = true;
    } else if (!needsPointer && this._pointerBound) {
      document.removeEventListener('pointermove', this._onPointerMove);
      this._pointerBound = false;
    }
  }

  _onPointerMove(e) {
    this._moveOverlays(e.clientY);
  }

  _moveOverlays(y) {
    const band = 150;
    if (this.overlays.maskTop) {
      this.overlays.maskTop.style.height = Math.max(0, y - band / 2) + 'px';
      this.overlays.maskBottom.style.height = Math.max(0, window.innerHeight - y - band / 2) + 'px';
    }
    if (this.overlays.guide) {
      this.overlays.guide.style.top = Math.round(y) + 'px';
    }
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this._onKeydown);
    document.removeEventListener('pointermove', this._onPointerMove);
    if (this.observer) this.observer.disconnect();
  }
}

if (!window.customElements.get('accessibility-widget')) {
  window.customElements.define('accessibility-widget', AccessibilityWidget);
}
